/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_UpgradeInputs */

const en_directory_submit_upgrade = /** @type {(inputs: Directory_Submit_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade`)
};

const zh_directory_submit_upgrade = /** @type {(inputs: Directory_Submit_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升级`)
};

/**
* | output |
* | --- |
* | "Upgrade" |
*
* @param {Directory_Submit_UpgradeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_upgrade = /** @type {((inputs?: Directory_Submit_UpgradeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_UpgradeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_upgrade(inputs)
	return zh_directory_submit_upgrade(inputs)
});
export { directory_submit_upgrade as "directory.submit.upgrade" }